import { PropsWithChildren, JSX } from 'react';
import classNames from 'classnames';
import classes from './SkeletonPulse.module.scss';

interface IProps {
    className?: string;
    width?: string;
    height?: string;
    radius?: string;
}

export const SkeletonPulse = (props: PropsWithChildren<IProps>): JSX.Element => {
    const computedStyles = {
        width: props.width,
        height: props.height,
        borderRadius: props.radius,
    };

    return (
        <div className={classNames(classes.skeleton, props.className)} style={computedStyles}>
            {props.children}
        </div>
    );
};
